import { useNormalizedPublishedTime } from '@libs/getNormalizedPublishedTime'
import { RecommendedArticles_recommendedArticles_articles } from '@apollo-types/RecommendedArticles'
import { PageComponents } from '@libs/eventTracking/article/common'
import { appendUrlSearchParams } from '@libs/url-utils'

import DesktopRecommendedArticleCard from './DesktopRecommendedArticleCard'
import MobileRecommendedArticleCard from './MobileRecommendedArticleCard'
import { useCleanPostData } from '@features/post/contexts/CleanPostDataContext'
import { trackArticleReadMoreRecommenderEnterArticleEvent } from '@libs/eventTracking/article/article.read-more-recommender.enter-article'
import { publicUrl } from '@libs/appUrl'

interface RecommendedArticleCardProps {
  article?: RecommendedArticles_recommendedArticles_articles
}

function RecommendedArticleCard(props: RecommendedArticleCardProps) {
  const { url, publisher, publishedAt, coverImage, title, plainTextContent, postID, categories } =
    props.article
  const articleImage = {
    url: coverImage?.croppedUrl || publicUrl('/images/articleCardImagePlaceholder.svg'),
    noShaper: !coverImage?.croppedUrl,
  }
  const { post } = useCleanPostData()
  const trackEnterEvent = () => {
    trackArticleReadMoreRecommenderEnterArticleEvent(post, url, postID)
  }
  const recommendedUrl = appendUrlSearchParams(url, {
    fromPage: { pageName: 'article', pageComponent: PageComponents.READ_MORE_RECOMMENDER },
  })
  const publishedTime = useNormalizedPublishedTime(publishedAt)

  return (
    <>
      <DesktopRecommendedArticleCard
        recommendedUrl={recommendedUrl}
        title={title}
        articleImage={articleImage}
        publisher={publisher}
        plainTextContent={plainTextContent}
        publishedTime={publishedTime}
        trackEnterEvent={trackEnterEvent}
        categories={categories}
      />
      <MobileRecommendedArticleCard
        recommendedUrl={recommendedUrl}
        title={title}
        articleImage={articleImage}
        publisher={publisher}
        trackEnterEvent={trackEnterEvent}
        categories={categories}
      />
    </>
  )
}

export default RecommendedArticleCard
